import { trigger, transition, style, animate, state } from '@angular/animations';
import { Subject, takeUntil } from 'rxjs';
import { ToastService } from 'src/app/core/toast/toast.service';
import { AppInfoRequest } from 'src/app/model/global-interface';
import { BaseResponse } from 'src/app/model/response/base-response';
import { GlobalService } from 'src/app/services/global.service';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CustomgridOptions, GridColConfig } from 'src/app/core/custom-grid/custom-grid';
import { CustomGridComponent } from 'src/app/core/custom-grid/custom-grid.component';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { environment } from 'src/environments/environment';
import { CustomDialogComponent } from 'src/app/core/custom-dialog/custom-dialog.component';
import { EmailLogsResponse } from './email';
import { BrowserDetectorService } from 'src/app/services/browser-detector.service';
import { Router } from '@angular/router';
import { AppGlobalSettings, UserSettings, UserSettingsResponse } from './settings';
import { SettingsService } from './settings.service';
import { IdbService } from 'src/app/services/idb.service';
import _ from 'lodash';
import { slideDownUp } from 'src/app/core/global-app-animations';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    animations: [
        slideDownUp
    ],
    standalone: false
})
export class SettingsComponent implements OnInit, OnDestroy, AfterViewInit {

  private theEnd$: Subject<void> = new Subject<void>();

  @ViewChild(CustomGridComponent) Cgrid: CustomGridComponent | undefined;
  @ViewChild('mailDialog') mailDialog: CustomDialogComponent | undefined;

  ready: boolean = false;

  showMailLog: boolean = false;

  visibleData?: EmailLogsResponse;

  fuhrer: boolean = false;

  fuhrerBesties: Array<number> = [environment.UserRoles.superAdmin, environment.UserRoles.developer];
  
  pagesArray: string[] = []
  
  themeDark: boolean = false;

  version: string = environment.version;

  sidebarOpen: boolean = false;
  showText: boolean = false;
  isMobile: boolean = false;

  globalSettings: AppGlobalSettings | undefined;

  pageName: string = '';

  gridConfig: CustomgridOptions = {
    apiCallurl: 'api/user/email-log/get/lazy',
    rowsCallurl: '',
    apiTableName: ''
  }

  gridColConfig: GridColConfig[] = [
    {
      type: 'text',
      name: 'Destinatario',
      field: 'recipient',
      fieldOptions: {

      }
    },
    {
      type: 'text',
      name: 'Oggetto email',
      field: 'subject',
      fieldOptions: {

      }
    },

    {
      type: 'text',
      name: 'Anteprima email',
      field: 'bodyFormatted',
      fieldOptions: {

      }
    },
    {
      type: 'state',
      name: 'Ricevuta?',
      field: 'outcome',
      width: '30',
      fieldOptions: {

      }
    },
    {
      type: 'button',
      name: 'Visualizza',
      field: 'view',
      fieldOptions: {},
      width: '30',
      cssClass: "dl-button e-icons e-eye"
    }
  ];

  constructor(
    private localStorageS: LocalStorageService,
    private globalService: GlobalService,
    private toastService: ToastService,
    private browserService: BrowserDetectorService,
    private router: Router,
    private settingsService: SettingsService,
    private idbService: IdbService,
  ) {

  }

  hideShow() {

    this.showText = !this.showText
    setTimeout(() => {
      this.sidebarOpen = !this.sidebarOpen;
    }, 10);
    
  }


  ngOnInit(): void {
    setTimeout(() => {
      this.ready = true;
    }, 300);

    let urlArr = this.router.url.split('/');
    this.pageName = urlArr[urlArr.length - 1]

    this.isMobile = this.browserService.detectBrowserMobile();

    // if(session != null) {
    //   if(_.intersection(session.rolesId, this.fuhrerBesties).length > 0) {
    //     this.fuhrer = true;
    //   }else{
    //     this.fuhrer = false;
    //   }
    // }

    this.localStorageS.setTitolo(`Impostazioni`);
    //this.router.navigate(['/home/settings/memory']);

    this.settingsService.GetSettings().pipe(takeUntil(this.theEnd$)).subscribe({
      next: (res: AppGlobalSettings) => {

        if (res != undefined) {
          this.globalSettings = res;
        }

      },
      error: () => {

      }
    });
  }
  

  ngAfterViewInit(): void {
    // check if the page need a double reload
    let ref = this.localStorageS.getValue("refresh");
    if (ref != null && ref != undefined) {
      this.localStorageS.deleteValue("refresh");
      location.reload();
    }
  }

  ngOnDestroy(): void {
        this.theEnd$.next();
    this.theEnd$.complete();
  }

  view(event: any) {
    console.log(event)
    let data: EmailLogsResponse = event.data;
    this.visibleData = data;
    this.mailDialog?.open();
  }



  navigateTo(linkPart: string) {
    this.pageName = linkPart;
    this.router.navigate([`/home/settings/${linkPart}`]);
  }

}
